import path from 'path';

/** Electron specific modules that will fail for static html site */

export const electron = window.require ? window.require("electron") : null;
export const remote = electron ? electron.remote : null;
export const shell = electron ? electron.shell : null;
export const ipcRenderer = electron ? electron.ipcRenderer : null;
export const child = electron ? window.require("child_process") : null;
export const process = electron ? window.require("process") : null;
export const dialog = remote ? remote.dialog : null;
export const app = remote ? remote.app : null;
export const getCurrentWindow = electron ? electron.remote.getCurrentWindow : null;
export const Menu = remote ? remote.Menu : null;
export const fs = remote ? remote.require('fs') : null;
export const fsPromises = fs ? fs.promises : null;
export const csv = remote ? remote.require('fast-csv') : null;
export const copydir = remote ? remote.require('copy-dir') : null;
export const glob = remote ? remote.require('glob') : null;
export const isDevMode = remote ? (app.isPackaged === false) : false;
export const isStaticSite = !electron;
export const tempDirectoryPath = app
  ? path.join(app.getPath('userData'), "temp")
  : null;
export const logDirectoryPath = app
  ? path.join(app.getPath('userData'), "logs")
  : null;

export const getTempFilePath = (filename) => {
  return path.join(tempDirectoryPath, filename);
};

const createInitialFolder = () => {
  if (!electron) {
    return;
  }

  if (!fs.existsSync(tempDirectoryPath)) {
    console.log("Creating temporary file folder...");
    fs.mkdirSync(tempDirectoryPath);
  }

  if (!fs.existsSync(logDirectoryPath)) {
    console.log("Creating log output folder...");
    fs.mkdirSync(logDirectoryPath);
  }
};

createInitialFolder();

export const storage = remote ? remote.require('electron-json-storage-sync') : {
  get: () => {
    return {status: false};
  },
  set: () => {}
};
